// DO NOT EDIT THIS FILE !!!! GENERATED DURING BUILD TYPE : Ansible
export const DOL_VERSION='[production]8.0.22-13286(a0ec8f4ca4)-C02/11/2026-14:46:17-B02/11/2026-14:53:37' ;
export const DOL_VERSION_JSON = {
  dolVersion: "[production]8.0.22-13286(a0ec8f4ca4)-C02/11/2026-14:46:17-B02/11/2026-14:53:37",
  branch: "production",
  latestTag: "8.0.22",
  revCount: "13286",
  shortHash: "a0ec8f4ca4",
  longHash: "a0ec8f4ca4374a70f951aa64fe240842dd7e326f",
  dateCommit: "02/11/2026-14:46:17",
  dateBuild: "02/11/2026-14:53:37",
  buildType: "Ansible",
  } ;
